
function switchBroker(event) {
    const brokerName = event.target.value;

    if (brokerName) {
        const apiKeyField = document.getElementById(`api_key`);
        const secretKeyField = document.getElementById(`secret_key`);

        if (apiKeyField && secretKeyField) {
            apiKeyField.value = document.getElementById(`api_key_${brokerName}_value`).value;
            secretKeyField.value = document.getElementById(`secret_key_${brokerName}_value`).value;
        }
    }
}

const brokerSelect = document.getElementById('broker_name');

if (brokerSelect) {
    brokerSelect.addEventListener("change", switchBroker);
}
